import { SimpleType, UpdTable, Banner } from '@/types';
import { Mutations } from 'vuex-smart-module';
import GlobalState from './state';

export default class GlobalMutations extends Mutations<GlobalState> {
  SET_CITIES(cities: SimpleType[]) {
    this.state.cities = cities;
  }

  SET_REGIONS(regions: SimpleType[]) {
    this.state.regions = regions;
  }

  SIDEBAR_TOGGLE(toggle: boolean) {
    localStorage.setItem('is_mini_sidebar', String(toggle));
    this.state.is_mini_sidebar = toggle;
  }

  RERENDER_TABLES() {
    this.state.option = '';
    this.state.option = 'redraw';
  }

  UPDATE_TABLE_OPTION(value: string | null) {
    this.state.option = value;
  }

  NOTIFICATIONS_BAR_TOGGLE(toggle: boolean) {
    this.state.is_notification_bar = toggle;
  }

  POLLS_SIDEBAR_TOGGLE(toggle: boolean) {
    this.state.is_polls_sidebar = toggle;
  }

  SET_TIME(time: number) {
    this.state.time = time;
  }

  UPD_SIDEBAR_MINI_WITDH(sidebar_mini_width: string) {
    this.state.sidebar_mini_width = sidebar_mini_width;
  }

  SET_DESKTOP_WIDTH() {
    this.state.isDesktop = true;
    this.state.isLaptop = false;
    this.state.isTablet = false;
    this.state.isMobile = false;
  }

  SET_LAPTOP_WIDTH() {
    this.state.isDesktop = false;
    this.state.isLaptop = true;
    this.state.isTablet = false;
    this.state.isMobile = false;
  }

  SET_TABLET_WIDTH() {
    this.state.isDesktop = false;
    this.state.isLaptop = false;
    this.state.isTablet = true;
    this.state.isMobile = false;
  }

  SET_MOBILE_WIDTH() {
    this.state.isDesktop = false;
    this.state.isLaptop = false;
    this.state.isTablet = false;
    this.state.isMobile = true;
  }

  UPD_CLEAT_LOCALE_STORAGE(is_clear_locale_storage: boolean) {
    this.state.is_clear_locale_storage = is_clear_locale_storage;
  }

  UPD_TABLE_KEY(table_key: number) {
    this.state.table_key = table_key;
  }

  UPD_USER_GUIDE_PATH(path: string) {
    this.state.user_guide_path = path;
  }

  UPD_CONTACT_INFORMATION_PATH(path: string) {
    this.state.contact_information_path = path;
  }

  SET_BANNERS(banners: Banner[]) {
    this.state.banners = banners;
  }

  CLEAR_BANNERS() {
    this.state.banners = [];
  }

  SET_INFO_DIALOG_MODAL(value: boolean) {
    this.state.info_dialog_modal = value;
  }

  UPD_FAVORITS_TOOGLE(value: boolean) {
    this.state.favorits_toggle = value;
  }

  UPD_QUESTION_TOGGLE(value: boolean) {
    this.state.question_toggle = value;
  }

  SET_DADATA_ERROR_MESSAGE(value: string) {
    this.state.dadata_error_message = value;
  }

  DADATA_ERROR_MESSAGE_CLEAR() {
    this.state.dadata_error_message = '';
  }

  SET_DADATA_ERROR_MODAL_TOGGLE(value: boolean) {
    this.state.dadata_error_modal = value;
  }
}
